import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UniversalNavbar from '../../components/ui/UniversalNavbar';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const CheckEmail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const email = searchParams?.get('email') || '';
  const isVerified = searchParams?.get('verified') === '1';
  const pendingConferenceId = sessionStorage?.getItem('pendingSubmissionConferenceId');

  return (
    <div className="min-h-screen bg-background">
      <UniversalNavbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-card rounded-xl border border-border shadow-elevation-2 p-6 md:p-8">
          <div className="text-center mb-8">
            <div className={`inline-flex items-center justify-center w-16 h-16 mb-4 ${isVerified ? 'bg-success/10' : 'bg-primary/10'}`}>
              <Icon
                name={isVerified ? 'BadgeCheck' : 'Mail'}
                size={32}
                className={isVerified ? 'text-success' : 'text-primary'}
              />
            </div>
            <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-3">
              {isVerified ? t('checkEmail.titleVerified') : t('checkEmail.title')}
            </h1>
            <p className="text-base text-muted-foreground max-w-2xl mx-auto">
              {isVerified ? t('checkEmail.subtitleVerified') : t('checkEmail.subtitle')}
            </p>
          </div>

          <div className="space-y-4">
            {email && !isVerified && (
              <div className="rounded-lg border border-border bg-muted/40 p-4">
                <p className="text-sm text-muted-foreground mb-1">{t('checkEmail.sentTo')}</p>
                <p className="text-base font-medium text-foreground break-all">{email}</p>
              </div>
            )}

            <div className="rounded-lg border border-border bg-muted/30 p-4">
              <h2 className="text-sm font-medium text-foreground mb-2">
                {isVerified ? t('checkEmail.nextStep') : t('checkEmail.whatHappensNext')}
              </h2>
              <ul className="space-y-2 text-sm text-muted-foreground">
                {!isVerified && <li>• {t('checkEmail.step1')}</li>}
                <li>• {t('checkEmail.step2')}</li>
                <li>• {t('checkEmail.step3')}</li>
                {pendingConferenceId && <li>• {t('checkEmail.submissionSaved')}</li>}
              </ul>
            </div>

            {!isVerified && (
              <div className="rounded-lg border border-warning-border bg-warning-subtle p-4 text-sm text-warning">
                {t('checkEmail.didntReceive')}
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <Button
                variant="default"
                size="lg"
                onClick={() => navigate(user ? '/user-dashboard' : '/user-sign-in')}
                className="flex-1"
              >
                {isVerified ? (user ? t('checkEmail.continueToDashboard') : t('checkEmail.goToSignIn')) : t('checkEmail.goToSignIn')}
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate('/public-conference-board')}
                className="flex-1"
              >
                {t('checkEmail.browseConferences')}
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckEmail;
